"use client";
import React from "react";

interface LoadingFallbackProps {
  children: React.ReactNode;
  className?: string;
}

const LoadingFallback: React.FC<LoadingFallbackProps> = ({
  children,
  className = "",
}) => {
  return (
    <div className={`loading-fallback ${className}`}>
      <style jsx>{`
        .loading-fallback {
          min-height: 100vh;
          background-color: #ffffff;
          opacity: 0.8;
          transition: opacity 0.3s ease-in-out;
        }

        .loading-fallback.loaded {
          opacity: 1;
        }

        /* Skeleton animation */
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }

        .ant-skeleton,
        .ant-btn,
        .ant-input,
        .ant-select {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 1000px 100px;
          animation: shimmer 2s infinite;
        }

        /* Ngăn chặn flash bằng cách ẩn Ant components chưa styled */
        .ant-btn:not(.ant-btn-primary):not(.ant-btn-default) {
          visibility: hidden;
        }

        .ant-input:not(.ant-input-status-error):not(.ant-input-status-success) {
          visibility: hidden;
        }
      `}</style>
      <div className="animate-pulse">{children}</div>
    </div>
  );
};

export default LoadingFallback;
